import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const userModeration = {
  fetchUsersModeration: lazyModuleMethod(
    () => import('./fetchUsersModeration'),
    'default'
  ),
  acceptUserModeration: lazyModuleMethod(
    () => import('./acceptUserModeration'),
    'default'
  ),
  rejectUserModeration: lazyModuleMethod(
    () => import('./rejectUserModeration'),
    'default'
  ),
  fetchUserModeration: lazyModuleMethod(
    () => import('./fetchUserModeration'),
    'default'
  ),
}
